<template>

  <div>
    <button class="btn btn-sm m-l-lg m-b-sm" type="button" @click="chartOpen()" >
      {{ isOpen ? 'Close' : 'Open' }}
    </button>
    <span class="m-l-lg lead"> {{ chartName }} </span>

    <transition name="expand">
      <div v-if="isOpen">
        <apexchart type=line :height="this.height" :options="this.chartOptions" :series="this.series"/>
        <apexchart v-if="showBrush" type=line :height="this.height/2" :options="this.brushOptions" :series="this.seriesBrush" />
      </div>
    </transition>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import { startCase, toLower } from 'lodash'
import moment from 'moment-timezone'
import { DATE_FORMAT, DATE_FORMAT_US } from '../../mixins'

Vue.component('apexchart', VueApexCharts)
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    showBrush: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    uniqueName: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 240
    },
    chartOpenByDefault: {
      type: Boolean,
      default: false
    },
    channelData: {
      type: Boolean,
      default: true
    },
    filterParams: {
      type: Object
    }
  },

  created () {
    if (this.chartOpenByDefault) {
      this.chartOpen()
    }
  },

  data () {
    return {
      autoScaleYaxis: false,
      isOpen: false,
      trendline: null,
      chartData: []
    }
  },
  methods: {
    chartOpen () {
      this.isOpen = !this.isOpen
      this.$http.get(`business_intelligence/${this.uniqueName}/data`, { params: this.filterParams }).then(response => {
        this.chartData = this.channelData ? this.mapChannelData(response.data[0]) : (response.data[0] ? response.data[0].data : [])
        this.trendline = response.data[0].trendline
      })
    },
    mapChannelData (data) {
      if (!data) {
        return []
      }
      let result = []
      for (let key in data) {
        result.push({ data: data[key].data, name: data[key].name ? data[key].name : 'No Source' })
      }
      return result
    }
  },
  computed: {
    chartName () {
      return startCase(toLower(this.name))
    },
    series () {
      if (this.type === 'multi') {
        return this.chartData
      } else {
        return [
          { data: this.chartData, name: this.name },
          { data: this.trendline || [], name: 'trend' }
        ]
      }
    },

    seriesBrush () {
      if (this.type === 'multi') {
        return this.chartData
      } else {
        return [
          { data: this.chartData, name: this.name }
        ]
      }
    },

    chartOptions () {
      return {
        title: {
          text: startCase(toLower(this.name)),
          align: 'left',
          offsetY: 15
        },
        chart: {
          id: this.name,
          toolbar: {
            tools: {
              download: true,
              selection: !this.showBrush,
              zoom: !this.showBrush,
              zoomin: !this.showBrush,
              zoomout: !this.showBrush,
              pan: !this.showBrush,
              reset: !this.showBrush,
              customIcons: []
            },

            show: true
          },
          name: this.name,
          type: 'line'
        },
        stroke: {
          dashArray: this.type === 'multi' ? [] : [0, 5],
          width: 3
        },
        xaxis: {
          type: 'datetime',
          show: false,
          labels: {
            datetimeFormatter: {
              day: this.$user.date_format_preference === 'day-first' ? 'dd MMM' : 'MMM dd'
            }
          }
        },
        tooltip: {
          x: {
            formatter: (val) => {
              if (!val) {
                return null
              }
              let format = DATE_FORMAT
              if (this.$user.date_format_preference && this.$user.date_format_preference === 'month-first') {
                format = DATE_FORMAT_US
              }
              return moment(val).format(format) + ' - ' + moment(val).add(6, 'days').format(format)
            }
          }
        },
        reversed: true
      }
    },

    brushOptions () {
      return {
        legend: {
          show: false
        },
        chart: {
          id: this.name + 'Brush',
          brush: {
            target: this.name,
            enabled: true,
            autoScaleYaxis: this.autoScaleYaxis
          },
          selection: {
            enabled: true,
            xaxis: {
              min: new Date(2018, 5, 10).getTime(),
              max: new Date().getTime()
            }
          },
          type: 'line'
        },
        colors: ['#008FFB'],
        fill: {
          type: 'gradient',
          gradient: {
            type: 'vertical',
            opacityFrom: 0.91,
            opacityTo: 0.8
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          }
        }
      }
    }
  }
}
</script>
